import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import { IFaqRO, IAdminFaqSave } from 'api'
import { useNavigate } from 'react-router-dom'

export default function FaqDetail() {
  const navigate = useNavigate()
  const id = useQueryValue('id', '')

  const { data: faqList, isFetching } = useApi({
    id: 'faqList',
    fn: api().adminFaq.adminFaqList,
  })

  const { data, refetch } = useApi({
    id: 'faqDetail',
    fn: api().adminFaq.adminFaqDetail,
    params: Number(id),
    enabled: !!id,
  })

  const onSave = async (data: IFaqRO) => {
    const saveData: IAdminFaqSave = {
      question: data.question,
      answer: data.answer,
      order: id ? data.order : faqList?.items.length + 1,
    }

    if (id) {
      await api().adminFaq.adminFaqUpdate(Number(id), saveData)
      navigate(`/faq`, { replace: true })
    } else {
      const res = await api().adminFaq.adminFaqCreate(saveData)

      navigate(`/faq`, { replace: true })
    }

    refetch()
  }

  const onDelete = async () => {
    if (id) {
      await api().adminFaq.adminFaqDelete({ ids: [Number(id)] })
      navigate(`/faq`, { replace: true })
    }
  }

  return (
    <ContentDetailView
      title="FAQ 수정"
      data={data}
      onSave={onSave}
      onDelete={onDelete}
    >
      <DetailForm
        data={data}
        fields={[
          {
            label: '질문',
            key: 'question',
            type: FormFieldType.STRING,
            required: true,
          },
          {
            label: '답변',
            key: 'answer',
            type: FormFieldType.CKEDITOR,
            required: true,
          },
          // {
          //   label: '순서',
          //   key: 'order',
          //   type: FormFieldType.NUMBER,
          //   required: true,
          // },
        ]}
      />
    </ContentDetailView>
  )
}
